module.exports = __webpack_public_path__ + "static/media/dNorcross.b38df6df.jpeg";